module.exports = __webpack_public_path__ + "static/media/reservoir_2.c4130497.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reservoir_2.png
// module id = 19
// module chunks = 0